import { DrawerContent as ChakraDrawerContent } from '@chakra-ui/react'

import { DrawerContentProps } from './DrawerContent.types'

export default function Drawer(props: DrawerContentProps) {
  return <ChakraDrawerContent {...props} translate="no" />
}
